import { AdaptiveBitrateController, validateQualityLadder } from "./abr-controller.js";
import {
	isMulticastExplicitlyDisabled,
	isUsableMulticastEndpoint,
	isValidMulticastGroupAddress,
	multicastEndpointKey,
	normalizeMulticastEndpoint,
	readUrlMulticastConfig,
	toWindowMulticastSubscribeConfig,
} from "./endpoint-config.js";
import { MulticastOrchestrator } from "./multicast-orchestrator.js";
import {
	catalogTierEndpoints,
	endpointToMulticastConfig,
	hasMulticastCatalogBaseline,
	hasUnicastMediaRenditions,
	isMulticastOnlyCatalog,
	isRecoverableMulticastSignalReadError,
	mergeUrlMulticastPolicy,
	normalizeMulticastConfig,
	readPlayerMulticastConfig,
	requiresMulticastCapability,
	sameMulticastConfig,
	selectEndpointPacketIds,
	selectMulticastCandidate,
	selectRepairEndpointsForTracks,
	catalogQualityLadder,
	urlOverrideBlocksMulticastCandidate,
	withCatalogNamespace,
	withMulticastEndpoints,
} from "./multicast-catalog-policy.js";
import {
	createMulticastSignalingReconciler,
	normalizeCatalogEndpoints,
} from "./multicast-signaling-reconciler.js";
import { MulticastSubscriptionPool } from "./multicast-subscription-pool.js";
import { endpointKey, selectMulticastTier } from "./multicast-tier.js";
import {
	MOQT_PUBLISHER_PRIORITY,
	MOQT_SUBSCRIBER_PRIORITY,
	moqtPublisherPriority,
	moqtSubscriberPriority,
} from "./moqt-priority.js";
import { classifyStall, TransportStallDetector } from "./stall-detector.js";
import { makeSourceSwitchHandler, wireStarvationDetector } from "./takeover.js";
import { TransportManager } from "./transport-manager.js";
import { runUnicastFallback } from "./unicast-fallback.js";

const api = {
	AdaptiveBitrateController,
	validateQualityLadder,
	catalogQualityLadder,
	catalogTierEndpoints,
	classifyStall,
	createMulticastSignalingReconciler,
	endpointToMulticastConfig,
	hasMulticastCatalogBaseline,
	hasUnicastMediaRenditions,
	isRecoverableMulticastSignalReadError,
	isMulticastOnlyCatalog,
	MulticastOrchestrator,
	MulticastSubscriptionPool,
	MOQT_PUBLISHER_PRIORITY,
	MOQT_SUBSCRIBER_PRIORITY,
	moqtPublisherPriority,
	moqtSubscriberPriority,
	TransportManager,
	TransportStallDetector,
	endpointKey,
	isMulticastExplicitlyDisabled,
	isUsableMulticastEndpoint,
	isValidMulticastGroupAddress,
	makeSourceSwitchHandler,
	mergeUrlMulticastPolicy,
	multicastEndpointKey,
	normalizeCatalogEndpoints,
	normalizeMulticastConfig,
	normalizeMulticastEndpoint,
	readPlayerMulticastConfig,
	readUrlMulticastConfig,
	toWindowMulticastSubscribeConfig,
	requiresMulticastCapability,
	runUnicastFallback,
	sameMulticastConfig,
	selectEndpointPacketIds,
	selectMulticastCandidate,
	selectMulticastTier,
	selectRepairEndpointsForTracks,
	urlOverrideBlocksMulticastCandidate,
	withCatalogNamespace,
	withMulticastEndpoints,
	wireStarvationDetector,
};

Object.defineProperty(globalThis, "__MmtTransport", {
	configurable: true,
	enumerable: false,
	writable: false,
	value: Object.freeze(api),
});

export default api;
